import React from "react";
import PubSub from "pubsub-js";
import t from "../i18n";

function Facebook() {
    return <svg xmlns="http://www.w3.org/2000/svg" id="Layer_1" data-name="Layer 1" height="24px" width="24px" viewBox="0 0 72 72">
        <path style={{fill: "#fff"}} d="M68,0H4A4,4,0,0,0,0,4V68a4,4,0,0,0,4,4H38.46V44.16H29.11V33.26h9.35v-8c0-9.3,5.68-14.37,14-14.37a77.46,77.46,0,0,1,8.38.43V21H55.1c-4.51,0-5.39,2.15-5.39,5.3v6.94H60.5l-1.4,10.9H49.71V72H68a4,4,0,0,0,4-4V4A4,4,0,0,0,68,0Z" />
        <path id="f" style={{fill: "#4267b2"}} d="M49.71,72V44.16H59.1l1.4-10.9H49.71V26.32c0-3.15.88-5.3,5.39-5.3h5.72V11.3a77.46,77.46,0,0,0-8.38-.43c-8.3,0-14,5.07-14,14.37v8H29.11v10.9h9.35V72Z" />
    </svg>;
}
function Google() {
    return <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" version="1.1">
        <g id="Google-Button" style={{ fill: "none", fillRule: "evenodd", stroke: "none", strokeWidth: 1 }} transform="matrix(1.3333333,0,0,1.3333333,-18.666666,-18.666666)">
            <g id="btn_google_light_normal" transform="translate(-1,-1)">
                <g id="logo_googleg_48dp" transform="translate(15,15)">
                    <path id="Shape" style={{ fill: "#4285f4" }}
                        d="m 17.64,9.2045455 c 0,-0.6381819 -0.05727,-1.2518182 -0.163636,-1.8409091 H 9 V 10.845 h 4.843636 C 13.635,11.97 13.000909,12.923182 12.047727,13.561364 v 2.258182 h 2.908637 C 16.658182,14.252727 17.64,11.945455 17.64,9.2045455 Z" />
                    <path id="path3720" style={{ fill: "#34a853" }}
                        d="m 9,18 c 2.43,0 4.467273,-0.805909 5.956364,-2.180454 L 12.047727,13.561364 C 11.241818,14.101364 10.210909,14.420455 9,14.420455 6.6559091,14.420455 4.6718182,12.837273 3.9640909,10.71 H 0.95727273 v 2.331818 C 2.4381818,15.983182 5.4818182,18 9,18 Z" />
                    <path id="path3722" style={{ fill: "#fbbc05" }}
                        d="M 3.9640909,10.71 C 3.7840909,10.17 3.6818182,9.5931818 3.6818182,9 c 0,-0.5931818 0.1022727,-1.17 0.2822727,-1.71 V 4.9581818 H 0.95727273 C 0.34772727,6.1731818 0,7.5477273 0,9 c 0,1.452273 0.34772727,2.826818 0.95727273,4.041818 z" />
                    <path id="path3724" style={{ fill: "#ea4335" }}
                        d="m 9,3.5795455 c 1.321364,0 2.507727,0.4540909 3.440455,1.3459091 L 15.021818,2.3440909 C 13.463182,0.89181818 11.425909,0 9,0 5.4818182,0 2.4381818,2.0168182 0.95727273,4.9581818 L 3.9640909,7.29 C 4.6718182,5.1627273 6.6559091,3.5795455 9,3.5795455 Z" />
                    <path id="path3726" d="M 0,0 H 18 V 18 H 0 Z" />
                </g>
            </g>
        </g>
    </svg>;
}
export class Social extends React.Component<{ onLoginSuccess: () => void }> {
    initiateSocialLogin = (name: string) => {
        // tslint:disable-next-line:no-string-literal
        //@ts-ignore
        window["socialLoginCallback"] = (url: string, admin: boolean) => {
            if (admin === false) {
                PubSub.publish("AUTH", "LOGIN");
                if (this.props.onLoginSuccess) this.props.onLoginSuccess();
                // if (this.props.ok) this.props.ok(true);
                // else this.props.history.replace("/topup");
            } else {
                window.location.href = "/admin/index";
            }
        };
        this.startSocialLogin(name);
    }
    startSocialLogin = (name: string) => {
        const returnUrl = this.getParameterByName("ReturnUrl");
        const url = `/account/ExternalLogin?provider=${name}&ReturnUrl=${returnUrl ? returnUrl : ''}`;
        const screenHeight = (screen.height) * 0.7;
        const screenWidth = 400;
        const leftPosition = (screen.width) ? (screen.width - screenWidth) / 2 : 0;
        let topPosition = (screen.height) ? (screen.height - screenHeight) / 2 : 0;
        topPosition = topPosition - 50;
        const settings = 'height=' + screenHeight + ',width=' + screenWidth + ',top=' + topPosition + ',left=' + leftPosition + ',scrollbars=yes,resizable=yes,toolbar=no,status=no,menu=no, directories=no,titlebar=no,location=no,addressbar=no'
        const newwindow = window.open(url, name, settings)!;
        if (newwindow && newwindow.focus) { newwindow.focus(); }
    }
    getParameterByName = (name: string, url?: string) => {
        if (!url) url = window.location.href;
        name = name.replace(/[\[\]]/g, "\\$&");
        const regex = new RegExp("[?&]" + name + "(=([^&#]*)|&|#|$)");
        const results = regex.exec(url);
        if (!results) return null;
        if (!results[2]) return '';
        return decodeURIComponent(results[2].replace(/\+/g, " "));
    }
    render() {
        return <React.Fragment>
            <a className="social-button google" onClick={e => this.initiateSocialLogin("Google")}>
                <div className="social-icon">
                    {/* <i className="fa fa-google" /> */}
                    <Google />
                </div>
                <span className="social-text">{t.social("sign_in_google")}</span>
            </a>
            <div style={{ height: 10 }} />
            <a className="social-button facebook" onClick={e => this.initiateSocialLogin("Facebook")}>
                <div className="social-icon">
                    {/* <i className="fa fa-facebook-f" /> */}
                    <Facebook />
                </div>
                <span className="social-text">{t.social("sign_in_facebook")}</span>
            </a>
            <hr />
        </React.Fragment>;
    }
}